export default "__VITE_ASSET__BQpC7Gup__"